"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsEditors_de_de = void 0;
function componentsEditors_de_de() {
    return {
        "components.editors.monaco.editorloading": "Editor wird geladen",
        "components.editors.styleeditor.csstitle": "Benutzerdefinierte Styles",
        "components.editors.styleeditor.cssclasstitle": "Eigene CSS Klassen",
        "components.editors.styleeditor.cssclasshint": "Fügen Sie hier Ihre eigenen CSS Klassen hinzu",
        "components.editors.styleeditor.addnewstyle": "Neuen Style hinzufügen"
    };
}
exports.componentsEditors_de_de = componentsEditors_de_de;
